module.exports = __webpack_public_path__ + "static/media/snuggling.5f39e6f0.mp4";